import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import Form from 'react-bootstrap/Form';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import { FaSave, FaAngleLeft, FaCalendarAlt, FaTimes, FaPlus,
    //  FaLink 
    } from "react-icons/fa";
import { Formik } from "formik";
import * as yup from "yup";
import { API } from 'aws-amplify';
import DatePicker from 'react-datepicker';
import "react-datepicker/dist/react-datepicker.css";
import Moment from 'react-moment';
import moment from 'moment';
import { Link } from 'react-router-dom';

import { useToasts } from 'react-toast-notifications';
import './SiteDetail.scss';

const headers = {
    'x-api-key': process.env.REACT_APP_API_KEY,
    'Accept': 'application/json',
    'Content-Type': 'application/json',
    }

const params = {
    headers: headers,
}

const SiteDetail = (props) => {
    const { addToast } = useToasts();
    const [inst_date, setInst_date] = useState('');
    const [expiry_date, setExp_date] = useState('');
    const [isLoading, setLoading] = useState(true);
    const [isSiteEdit, setSiteEdit] = useState(false);
	const [locationList, setLocationList] = useState([]);
	const [countryList, setCountryList] = useState([]);
    const [locationAll, setLocationAll] = useState([]);
    const [showModal, setShowModal] = useState(false);
    const handleCloseModal = () => setShowModal(false);
    const handleShowModal = () => setShowModal(true);

    const [site, setSite] = useState({id: null,
                                        name: '',
                                        make: '',
                                        address: '',
                                        location: '',
                                        latitude: '',
                                        longitude: '',
                                        add_info: '',
                                        inst_date: '',
                                        expiry_date: '',
                                        vpn: '',
                                        status: 'active',
                                        date_created: new Date().toISOString(),
                                        active: true,
                                    });
    const [assets, setAssets] = useState([]);                          

    let formatDate = ['DD-MM-YYYY','dd/MM/yyyy']
    if (props.formatDate!==formatDate[0]){
        formatDate = ['MM-DD-YYYY','MM/dd/yyyy']
    }

    // locations
    useEffect(()=>{
        const fetchLocation = async () => {

            const locations = await API.get('location','/country', params)

            // console.log(locations.values)
            let loc = Object.entries(locations.values).reduce((a,[k,v]) => (v === null || v === '' ? a : {...a, [k]:v}), {})
            // console.log(Object.entries(locations.values)[0][0])

            const country = Object.keys(locations.values)
            // county.sort((a, b) => (a > b) ? 1 : -1)

            let list = []

            for (let i = 0; i < country.length; i++) {
                list.push(<option key={`country`+i} value={country[i]}>{country[i]}</option>)
            }

            setLocationAll(loc);
            setCountryList(list);
        }
        fetchLocation();
    }, []);

    // Load site
    useEffect(() => {
        let isMounted = true; // flag to prevent state updates if unmounted
        let didRun = false;   // flag to prevent double fetch

        const fetchSite = async () => {
            if (didRun) return;
            didRun = true;

            if (props.match.params.id) {
                setLoading(true);
                try {
                    const [res, assetAll] = await Promise.all([
                        API.get('sites', '/' + props.match.params.id, params),
                        API.get('site_assets', '/' + props.match.params.id, params)
                    ]);

                    if (!isMounted) return;

                    if (res.inst_date === undefined)
                        res.inst_date = '';
                    else
                        setInst_date(new Date(res.inst_date));

                    if (res.expiry_date === undefined)
                        res.expiry_date = '';
                    else
                        setExp_date(new Date(res.expiry_date));

                    if (res.status === undefined)
                        res.status = 'active';

                    handleLocations(res.country);

                    setSite(res);

                    const processedAssets = assetAll.map(item => {
                        let stat = 'text-success';
                        switch (item.status) {
                            case 'active':
                                stat = 'text-success';
                                break;
                            case 'inactive':
                                stat = 'text-secondary';
                                break;
                            case 'removed':
                                stat = 'text-danger';
                                break;
                            default:
                                stat = 'text-success';
                        }
                        return { ...item, statusCss: stat };
                    });
                    setAssets(processedAssets);

                    setSiteEdit(true);
                } catch (error) {
                    // Optionally handle error
                } finally {
                    if (isMounted) setLoading(false);
                }
            } else {
                setLoading(false);
            }
        };

        fetchSite();

        return () => {
            isMounted = false;
        };
        // Only run when id changes, not on locationAll
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [props.match.params.id]);

    const handleSubmit = async (data) => {


        //Edit task
        if (site.id !== null){
            data.id = site.id
       }else{
            data.id = data.serial_number

            // add new site to user access list
            // const user_assets = await API.get('user_assets','/' + props.user.username, params)
            // API.post('user_assets', '/', {
            //     body: {
            //         id: user_assets.id,
            //         assets: [...user_assets.assets, data.id],
            //         views: user_assets.views,
            //         settings: user_assets.settings
            //     },
            //     headers,
            // });
       }


       //Clean up data before Post
       data = Object.entries(data).reduce((a,[k,v]) => (v === null || v === '' ? a : {...a, [k]:v}), {})

    //    console.log(data)
       API.post('sites', '/', {
           body: data,
           headers,
       })
       .then(response => {
        //    console.log(response)
           addToast('Site Saved', { appearance: 'success' });
           props.history.push('/sites/' );
       }).catch(error => {
           console.log(error)
           addToast('Error Saving Site', { appearance: 'error' });
       });
    }



    const handleDelete = async (id) => {
        setShowModal(false);

        // console.log('SITE ',id)
        // delete site
        // API.del('sites', '/' + id, params)
        // .then(res => {
        //     addToast('Site Deleted', { appearance: 'success' });
        //     props.history.push('/sites');
        // }).catch(error => {
        //     console.log(error)
        //     addToast('Error Deleting Site', { appearance: 'error' });
        // });

        const data = {...site, active: false}

        API.post('sites', '/', {
            body: data,
            headers,
        })
        .then(response => {
         //    console.log(response)
            addToast('Site Deleted', { appearance: 'success' });
            props.history.push('/sites/' );
        }).catch(error => {
            console.log(error)
            addToast('Error Deleting Site', { appearance: 'error' });
        });
    }

    const handleLocations = (item) => {
        const list = []

        if (locationAll[item]){
            const loc = locationAll[item]
            for (let i = 0; i < loc.length; i++) {
                list.push(<option key={`loc`+i} value={loc[i]}>{loc[i]}</option>)
            }
        }

        setLocationList(list);

    }

    // const handleOpenWebUI = () => {
    //     // fetch('/iniciar-conexion-vpn', {
    //     //     method: 'POST'
    //     // })
    //     // .then(response => {
    //     //     if (response.ok) {
    //     //         console.log('Conexión VPN iniciada con éxito');
    //     //         this.accederALocalhost();
    //     //     } else {
    //     //         console.error('Error al iniciar la conexión VPN');
    //     //     }
    //     // })
    //     // .catch(error => {
    //     //     console.error('Error al iniciar la conexión VPN', error);
    //     // });

    // }

    const schema = yup.object().shape({
		name: yup.string()
            .required('Required'),
        address: yup.string()
            .required('Required'),
        location: yup.string()
            .required('Required'),
        latitude: yup.number()
            .typeError("This is not a valid number")
            .required("Required"),
        longitude: yup.number()
            .typeError("This is not a valid number")
            .required("Required"),
        inst_date: yup.string(),
        expiry_date: yup.string(),
        });

	return (
    !isLoading ? (
    <Formik
    initialValues={site}
    validationSchema={schema}
    onSubmit={ (values, { setSubmitting }) => {
        handleSubmit(values);
        setSubmitting(false);
    }}
    >
    {({values, errors, touched, handleChange, handleBlur, handleSubmit, isSubmitting, setFieldValue }) => (
    <div className="SiteDetail">
        <div className="col-md-12">
        <form key="form" onSubmit={handleSubmit}>
            <div className="row header">
                <div className="col-4">{isSiteEdit ? 'Edit':'New'} Site</div>
                <div className="col-4 d-flex align-items-end">
                {/* {site.last_update ?
                    <h5 className='text-secondary'>
                    data updated @&nbsp;
                    <Moment local format={formatDate[0] + " HH:mm:ss"} date={ site.last_update } className={ moment(site.last_update).isSameOrAfter(new Date(), "day") ? "text-secondary" : "text-danger" } />
                    </h5>
                :''} */}
                </div>
                <div className="col-4 d-flex justify-content-end">
                    <Button variant="secondary" className="mr-1 text-nowrap" onClick={()=>{props.history.goBack()}}>
                        Back &nbsp;
                        <FaAngleLeft />
                    </Button>
                    {(props.viewPermissions.find(i => i === 'edit_site'))?
                    <Button variant="success" className="mr-1 text-nowrap" type="submit" >
                        Save &nbsp;
                        <FaSave />
                    </Button>
                    :''}
                    {(props.viewPermissions.find(i => i === 'delete_site'))?
                    <Button variant="danger" className="mr-1 text-nowrap" type="button" onClick={handleShowModal} >
                        Delete &nbsp;
                        <FaTimes />
                    </Button>
                    :''}
                    {/* {(props.viewPermissions.find(i => i === 'edit_site'))?
                    <Button variant="warning" className="mr-1 text-nowrap" type="button" onClick={handleOpenWebUI} >
                        Web UI &nbsp;
                        <FaLink />
                    </Button>
                    :''} */}
                </div>
            </div>
            <div className="row div-content">
                <div className="col-md-12">
                    <div className="row">
                        <div className="col-md-8"> 
                        <div className="row"> 
                            <div className="col-md-9 pb-3">
                                <Form.Group controlId="name" className={touched.name && errors.name ? "has-error" : null}>
                                    <Form.Label>Name</Form.Label>
                                    <Form.Control
                                    as="input"
                                    value={values.name}
                                    onChange={handleChange}
                                    />
                                    {touched.name && errors.name ? <div className="error-message">{errors.name}</div> : null}
                                </Form.Group>
                                </div>
                                <div className="col-md-3 pb-3">
                                <Form.Group controlId="status" className={touched.status && errors.status ? "has-error" : null}>
                                    <Form.Label>Status</Form.Label>
                                    <Form.Control
                                        as="select"
                                        value={values.status}
                                        onChange={handleChange}
                                        disabled={props.user.administrator==='false'}>
                                            <option default value="active">Active</option>
                                            <option value="inactive">Inactive</option>
                                            <option value="removed">Removed</option>
                                    </Form.Control>
                                    {touched.status && errors.status ? <div className="error-message">{errors.status}</div> : null}
                                </Form.Group>
                                </div>
                                <div className="col-md-3 pb-3">
                                <Form.Group controlId="country" className={touched.country && errors.country ? "has-error" : null}>
                                    <Form.Label>Country</Form.Label>
                                    <Form.Control
                                        as="select"
                                        value={values.country}
                                        onChange={e => {
                                            handleChange(e);
                                            handleLocations(e.target.value);
                                            }}>
                                            <option value=""></option>
                                            {countryList}
                                    </Form.Control>
                                    {touched.country && errors.country ? <div className="error-message">{errors.country}</div> : null}
                                </Form.Group>
                                </div>
                                <div className="col-md-3 pb-3">
                                <Form.Group controlId="location" className={touched.location && errors.location ? "has-error" : null}>
                                    <Form.Label>Location</Form.Label>
                                    <Form.Control
                                        as="select"
                                        value={values.location}
                                        onChange={handleChange}>
                                            <option value=""></option>
                                            {locationList}
                                    </Form.Control>
                                    {touched.location && errors.location ? <div className="error-message">{errors.location}</div> : null}
                                </Form.Group>
                                </div>
                                <div className="col-md-6 pb-3">
                                <Form.Group controlId="address" className={touched.address && errors.address ? "has-error" : null}>
                                    <Form.Label>Address</Form.Label>
                                    <Form.Control
                                    as="input"
                                    value={values.address}
                                    onChange={handleChange}
                                    />
                                    {touched.address && errors.address ? <div className="error-message">{errors.address}</div> : null}
                                </Form.Group>
                                </div>
                                <div className="col-md-3 pb-3">
                                <Form.Group controlId="make" className={touched.make && errors.make ? "has-error" : null}>
                                    <Form.Label>Make</Form.Label>
                                    <Form.Control
                                    as="input"
                                    value={values.make}
                                    onChange={handleChange}
                                    />
                                    {touched.make && errors.make ? <div className="error-message">{errors.make}</div> : null}
                                </Form.Group>
                                </div>
                                <div className="col-md-3 pb-3">
                                <Form.Group controlId="vpn" className={touched.vpn && errors.vpn ? "has-error" : null}>
                                    <Form.Label>VPN</Form.Label>
                                    <Form.Control
                                    as="input"
                                    value={values.vpn}
                                    onChange={handleChange}
                                    />
                                    {touched.vpn && errors.vpn ? <div className="error-message">{errors.vpn}</div> : null}
                                </Form.Group>
                                </div>
                                <div className="col-md-3 pb-3">
                                    <Form.Group controlId="inst_date">
                                        <Form.Label><FaCalendarAlt className="text-secondary" /> Installation Date</Form.Label>
                                        <div>
                                        <DatePicker
                                        dateFormat={formatDate[1]}
                                        selected={inst_date}
                                        onChange={e => {
                                            setInst_date(e)
                                            setFieldValue('inst_date', e, false);
                                            }}
                                        disabled={props.user.administrator==='false'}
                                        className="form-control"/>
                                        </div>
                                    </Form.Group>
                                </div>
                                <div className="col-md-3 pb-3">
                                <Form.Group controlId="expiry_date">
                                    <Form.Label><FaCalendarAlt className="text-secondary" /> Expiry Date</Form.Label>
                                    <div>
                                    <DatePicker
                                    dateFormat={formatDate[1]}
                                    selected={expiry_date}
                                    onChange={e => {
                                        setExp_date(e)
                                        setFieldValue('expiry_date', e, false);
                                        }}
                                    className="form-control"/>
                                    </div>
                                </Form.Group>
                                </div>

                                <div className="col-md-3 pb-3 bg-light rounded border">
                                <h4 className='pt-2'>GPS Coordinates</h4>
                                <Form.Group controlId="latitude" className={touched.latitude && errors.latitude ? "has-error" : null}>
                                    <Form.Label>Latitude</Form.Label>
                                    <Form.Control
                                    as="input"
                                    value={values.latitude}
                                    onChange={handleChange}
                                    type="number"
                                    step="0.00000001"
                                    />
                                    {touched.latitude && errors.latitude ? <div className="error-message">{errors.latitude}</div> : null}
                                </Form.Group>
                                {/* </div>
                                <div className="col-md-3 pb-3"> */}
                                <Form.Group controlId="longitude" className={touched.longitude && errors.longitude ? "has-error" : null}>
                               
                                    <Form.Label>Longitude</Form.Label> 
                                    <Form.Control
                                    as="input"
                                    value={values.longitude}
                                    onChange={handleChange}
                                    type="number"
                                    step="0.00000001"
                                    />
                                    {touched.longitude && errors.longitude ? <div className="error-message">{errors.longitude}</div> : null}
                                </Form.Group>
                                </div>
                                <div className="col-md-9 pb-3">
                                <Form.Group controlId="additional_info" className={touched.additional_info && errors.additional_info ? "has-error" : null}>
                                    <Form.Label>Additional Information</Form.Label>
                                    <Form.Control
                                    as="textarea"
                                    rows="5"
                                    value={values.additional_info}
                                    onChange={handleChange}
                                    />
                                    {touched.additional_info && errors.additional_info ? <div className="error-message">{errors.additional_info}</div> : null}
                                </Form.Group>
                                </div>
                        </div>
                        </div>
                        {/* SENSORS START */}
                        {/* {(site.id)? */}
                        <div className="col-md-4 bg-light p-3 border rounded"> 
                            <div className="row pb-4"> 
                                <div className='col-6'>
                                    <h2>Sensors</h2>
                                </div>                           
                                <div className='col-6 d-flex justify-content-end'>   
                                {(props.viewPermissions.find(i => i === 'add_asset'))?                        
                                    <Button variant="primary" 
                                    size="sm" 
                                    className="mr-1 text-nowrap" 
                                    type="button" 
                                    onClick={()=>{props.history.push('/device_add/' +  site.id)}}
                                    disabled={site.id===null}
                                    >
                                        Add Sensor &nbsp;
                                        <FaPlus />
                                    </Button>
                                :''}
                                </div>
                            </div>
                            <div className="row p-2">
                                {assets.map((item, i) =>

                                <Link to={`/device_det/${item.id}`} className="text-body w-100" key={item.id}>
                                    <div className='col-12 my-1 linkbtn' 
                                        key={"sens"+ i}>
                                        <div className='row'>
                                            <div className='col-3 p-2 mr-0  assetId'>{item.id} 
                                                <span className={'small ' + item.statusCss}><br/>{item.status}</span>
                                            </div>
                                            <div className='col-9 p-0 ml-0 bg-white'>
                                                <div className='border-bottom p-3'>{item.name}</div>
                                                <div>                                           
                                                {item.last_update ?
                                                    <h5 className='text-secondary pl-3 pb-0'>
                                                    last update @&nbsp;
                                                    <Moment local format={formatDate[0] + " HH:mm:ss"} date={ item.last_update } className={ moment(item.last_update).isSameOrAfter(new Date(), "day") ? "text-secondary" : "text-danger" } />
                                                    </h5>
                                                :<h5 className='text-secondary pl-3 pb-0'>last update not available</h5>}
                                                </div>
                                            </div>
                                        </div>                            
                                    </div>
                                </Link>
                                )}
                            </div>
                        </div>    
                        {/* :''} */}
                        {/* SENSORS END */}

                    </div>
                </div>
            </div>
            </form>
        </div>
        <Modal className="text-dark border-danger" show={showModal} onHide={handleCloseModal} animation={false} >
            <Modal.Header className="bg-danger text-light align-content-center" closeButton>
            <Modal.Title><h4><strong>Delete Site</strong></h4></Modal.Title>
            </Modal.Header>
            <Modal.Body>Please confirm that you really want to delete this site</Modal.Body>
            <Modal.Footer>
            <Button className="m-0 mr-2" variant="danger" onClick={() => {handleDelete(props.match.params.id)}}>
                Delete
            </Button>
            <Button className="m-0"  variant="secondary" onClick={handleCloseModal}>
                Close
            </Button>
            </Modal.Footer>
        </Modal>

    </div>
    )}
    </Formik>
    ) : ''
    );
}

const mapStateToProps = state => {
    return {
        user: state.auth.user,
        formatDate: state.auth.formatDate,
        viewPermissions: state.auth.viewPermissions,
    };
  };

export default connect(mapStateToProps)(SiteDetail);



